import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export type LessonRulesModalContext = {
  ruleId?: string | null;
};

let context: LessonRulesModalContext | null = null;

export function openLessonRulesModal(next?: LessonRulesModalContext): void {
  context = next ?? null;
  ModalComponent.attach("lessonRulesModal", appScope.id);
}

export function getLessonRulesModalContext(): LessonRulesModalContext | null {
  return context;
}

export function clearLessonRulesModalContext(): void {
  context = null;
}
